import React from 'react';

export default function About() {
  return (
    <div className="about-page" style={{ maxWidth: 600, margin: '40px auto', background: 'var(--color-surface)', color: 'var(--color-text-main)', borderRadius: 8, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', padding: '2rem' }}>
      <h2>À propos</h2>
      <p>
        <strong>EcotoneAI</strong> est une application de monitoring crypto permettant aux utilisateurs de :
      </p>
      <ul style={{ lineHeight: '1.8', marginTop: '1rem' }}>
        <li>suivre leurs portefeuilles crypto synchronisés avec plusieurs exchanges</li>
        <li>analyser le sentiment global du marché crypto</li>
        <li>
          afficher différents indicateurs :
          <ul style={{ marginTop: '0.5rem' }}>
            <li>Fear & Greed Index</li>
            <li>Crypto Heatmap</li>
            <li>Crypto Bubble</li>
            <li>Bitcoin Dominance (BTC.D)</li>
          </ul>
        </li>
      </ul>
    </div>
  );
}
